import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-card-name-matcher',
  templateUrl: './card-name-matcher.component.html',
  styleUrls: ['./card-name-matcher.component.scss'],
})
export class CardNameMatcherComponent implements OnInit {
  @Input()
  payment: any;

  @Input()
  chartererName: string;

  cardName: string;
  match: boolean;
  cardType: string;
  lastFour: string;

  constructor() {}

  ngOnInit() {
    if (
      this.payment &&
      this.payment.transactions &&
      this.payment.transactions.creditCard
    ) {
      this.cardName = this.payment.transactions.creditCard.cardholderName;
      this.cardType = this.payment.transactions.creditCard.cardType;
      this.lastFour = this.payment.transactions.creditCard.last4;
      if (
        this.payment.transactions.creditCard.cardholderName ===
        this.chartererName
      ) {
        this.match = true;
      } else {
        this.match = false;
      }
    }
  }
}
